import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ReleaseNewsItem {
  id: number;
  version: string;
  tag_name: string;
  subject: string;
  language: 'en' | 'tr';
  content: {
    preheader?: string;
    introduction?: string;
    highlights?: Array<{ title: string; description: string }>;
    fixes?: Array<{ title: string; description: string }>;
    call_to_action?: string;
  };
  published_at: string;
  seen: boolean;
  seen_at: string | null;
}

@Injectable({ providedIn: 'root' })
export class ReleaseNewsService {
  private readonly url = `${environment.baseUrl}/api/v1/release-news`;

  constructor(private http: HttpClient) {}

  history(): Observable<{ releases: ReleaseNewsItem[] }> {
    return this.http.get<{ releases: ReleaseNewsItem[] }>(this.url);
  }

  unseen(): Observable<{ releases: ReleaseNewsItem[] }> {
    return this.http.get<{ releases: ReleaseNewsItem[] }>(`${this.url}/unseen`);
  }

  markSeen(releaseIds: number[]): Observable<{ marked: number }> {
    return this.http.post<{ marked: number }>(`${this.url}/seen`, {
      release_ids: releaseIds,
    });
  }
}
